import { Store, createStore, applyMiddleware, Action } from 'redux';
import { IDialogAction } from '../actions/IDialogAction';
import { DialogState } from '../models/DialogState';
import {
    AddLikeAction,
    RemoveLikeAction,
    AddCommentAction,
    RemoveCommentAction,
    ChangeTabAction,
    SearchAction,
    ShowMoreAction,
    AddBookmarkAction,
    RemoveBookmarkAction,
    AddAudienceFilterAction,
    RemoveAudienceFilterAction,
    RemoveMessageAction,
    DialogActionTypeMapping
} from '../actions';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { DialogAudience } from '../models/feed/DialogAudience';

export interface IStateProvider {
}

const initialState: DialogState = {
    t: 0,
    hero: {
        title: '',
        description: '',
        url: '',
        image: {
            small: {
                src: ''
            },
            medium: {
                src: ''
            },
            large: {
                src: ''
            },
            alt: ''
        }
    },
    feed : {
        ready: false,
        messagesReady: false,
        currentTabId: '',
        audienceFilters: [],
        currentUser: {
            id: '',
            externalId: '',
            name: '',
            isAdmin: false,
            profileUrl: '',
            profilePhotoUrl: ''
        },
        categories: [],
        tabs: [],
        messages: [],
        newMessageCount: 0,
        pageNumber: 0,
        lastActivityId: 0,
        hasMoreMessages: false,
        enableLinkPreview: false,
        enableMessageSnippets: false
    }
};

export abstract class DialogReduxProvider implements IStateProvider {
    public static createStore(): Store {
        return createStore(
            this.globalReducer,
            applyMiddleware(this.globalMiddleware)
        );
    }
    public static mapStateToHeroProps(state: DialogState): any {
        return {
            t: state.t,
            ...state.hero
        }
    }
    public static mapStateToFeedProps(state: DialogState): any {
        return {
            t: state.t,
            feed: state.feed
        }
    }
    public static createMapDispatchToFeedProps(service: DialogSignalRService): Function {
        return (dispatch: Function): any => {
            return {
                like: (ids: number[]) => dispatch(new AddLikeAction({ userAction: true, ids: ids }, service)),
                unlike: (ids: number[]) => dispatch(new RemoveLikeAction({ userAction: true, ids: ids }, service)),
                bookmark: (id: number) => dispatch(new AddBookmarkAction({ userAction: true, id: id }, service)),
                unbookmark: (id: number) => dispatch(new RemoveBookmarkAction({ userAction: true, id: id }, service)),
                addComment: (parentIds: number[], text: string) => dispatch(new AddCommentAction({ userAction: true, parentIds: parentIds, text: text }, service)),
                removeComment: (ids: number[]) => dispatch(new RemoveCommentAction({ userAction: true, ids: ids }, service)),
                changeTab: (id: string) => dispatch(new ChangeTabAction({ id: id }, service)),
                search: (text: string) => dispatch(new SearchAction({ userAction: true, text: text }, service)),
                addAudienceFilter: (audiences: DialogAudience[]) => dispatch(new AddAudienceFilterAction({ userAction: true, audiences: audiences }, service)),
                removeAudienceFilter: (ids: string[]) => dispatch(new RemoveAudienceFilterAction({ userAction: true, ids: ids }, service)),
                showMore: () => dispatch(new ShowMoreAction({}, service)),
                removeMessage: (id: number) => dispatch(new RemoveMessageAction({ userAction: true, id: id }, service))
            }
        }
    }
    public static globalMiddleware(store: Store) {
        return (next: any) => (action: IDialogAction) => {
            if(action.middleware)
            {
                action.middleware(store);
            }
            return next(Object.assign({}, action));
        };
    }
    public static globalReducer(state: any, action: any): any {
        let newState = state && state.t ? Object.assign({}, state) : initialState;
        if(DialogActionTypeMapping[action.type]) {
            let rAction = new DialogActionTypeMapping[action.type](action.payload);
            newState.t = Date.now();
            return rAction.reducer(newState);
        }
        if(action.type === 'SET_CATEGORIES') {
            newState.t = Date.now();
            newState.feed.categories = action.payload;
            return newState;
        }
        return newState;
    }
}